/**
 * Site
 */

const Site = {
  race: ( data: any ) => {
    const reserved = data.reserved1 || '';
    if ( reserved && reserved.contents && reserved.contents.raceName ) {
      return `<span class="race">${reserved.contents.raceName}</span>`;
    }

    return '';
  },

  profileImg: ( data: any, defaultImage = '' ) => {
    const reserved = data.reserved1 || '';
    if ( reserved && reserved.contents && reserved.contents.profileImageUrl ) {
      return reserved.contents.profileImageUrl;
    }

    return defaultImage;

  },

  characterUrl: ( data: any ) => {
    const reserved = data.reserved2;
    if ( reserved && reserved.contents ) {
      return reserved.contents.characterUrl;
    }

    return '';
  },

  sandboxUrl: ( data: any ) => {
    const reserved = data.reserved2;
    if ( reserved && reserved.contents ) {
      return reserved.contents.sandboxUrl;
    }

    return '';
  },

  userInfo: ( data: any ) => {
    const reserved = data.reserved3 || '';
    return reserved.contents || {};
  },

  serverMaster: ( data: any ) => {
    const reserved = data.reserved1 || '';
    if ( reserved && reserved.contents ) {
      const constents = reserved.contents;
      return constents.PLAIN_TEXT_VALUE || constents.pLAINTEXTVALUE || '';
    }

    return '';
  },

  runningTime: ( data: any ) => {
    const reserved = data.reserved2 || '';
    if ( reserved && reserved.contents && reserved.contents.runningTime ) {
      return `<span class="running-time">${reserved.contents.runningTime}</span>`;
    }

    return '';
  },
};

export default Site;
